<template>
    <div
        class="wg-image"
        :class="{
            ['wg-shadow__' + finalBoxShadow]: finalBoxShadow,
            ['wg-gradient_' + realStyle.gradient]: realStyle.gradient,
            ['wg-background__none']: realStyle.backgroundColor === 'none',
            ['wg-bg-color__' + finalBackgroundColor]: finalBackgroundColor,
            ['wg-border__box']: realStyle.type,
            ['wg-border__radius-' + realStyle.type]: realStyle.type,
        }"
        :style="{
            width: imageWidth,
            minWidth: imageWidth,
            height: realStyle.type ? imageWidth : imageHeight,
            margin: finalMargin,
            padding: finalPadding,
            paddingBottom: realPaddingBottom,
            borderRadius: realBorderRadius,
            backgroundImage: lazyload ? '' : `url(${url || ''})`,
            backgroundSize: realStyle.backgroundSize ? realStyle.backgroundSize: 'cover'
        }"
        v-lazy:backgroundImage="{
            src: url || '',
            loading: lazyload ? '' : (url || '')
        }"
    >
        <slot></slot>

        <div class="wg-text__reddot" v-if="realDot">
            <wg-text :text="dotText" v-if="dotText" :styleObject="{backgroundColor: 'red', fontSize: 12, lineHeight: 14, color: 'white', fontWeight: 'bold'}" class="wg-text__reddot-text"></wg-text>
            <wg-text class="wg-text__reddot-dot" v-else :styleObject="{backgroundColor: 'red'}"></wg-text>
        </div>
    </div>
</template>
<script>
import Mixin from '../mixin.js';
import Env from 'common/env';

const borderTypeMap = {
    'game': '25%',
    'minigame': '100%',
    'avatar': '12.5%',
    'gift': '12.5%'
}
export default {
    mixins: [Mixin],
    data () {
        return {
            defaultStyle: {
                width: '100%',
                height: '56.25%',
                gradient: '',
                adapt: false,
                reddot: '',
                backgroundColor: ''
            },
            dotText: ''
        }
    },
    props: {
        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        },
        lazyload: {
            type: Boolean,
            default: true,
        },
        url: {
            type: String,
        }
    },
    computed: {
        realStyle () {
            return Object.assign(this.defaultStyle, (this.styleObject || {}))
        },
        realRatio() {
            return this.realStyle.adapt ? 0.853 : 1
        },
        imageWidth () {
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            return ('' + this.realStyle.width).indexOf('%') > -1 ? this.realStyle.width : (width < 359 ? (this.realStyle.width * this.realRatio) : this.realStyle.width) + 'px'
        },
        imageHeight () {
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            return ('' + this.realStyle.height).indexOf('%') > -1 ? this.realStyle.height : (width < 359 ? (this.realStyle.height * this.realRatio) : this.realStyle.height) + 'px'
        },
        realPaddingBottom () {
            let height = this.realStyle.height;
            if(this.realStyle.type) {
                height = this.realStyle.width;
            }
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            return ('' + height).indexOf('%') > -1 ? height : (width < 359 ? (height * this.realRatio) : height) + 'px'
        },
        realBorderRadius () {
            if(this.realStyle.type) {
                return borderTypeMap[this.realStyle.type] || this.borderRadius
            }
            return this.borderRadius
        },

        realDot () {
            if(this.realStyle.reddot) {
                if(this.realStyle.reddot === 'dot') {
                    this.dotText = ''
                }else {
                    this.dotText = this.realStyle.reddot
                }
                return true;
            }else {
                return false;
            }
        }
    }
}
</script>
<style lang="less">
</style>
